import { useLoadChatSocket } from "./use-load-chat-socket";
import { useCallback, useEffect, useState } from "react";
import { Client } from "@stomp/stompjs";
import { Message } from "../api/message-request";

export const useChatSocket = (
  messageSentCallback: (message: Message) => void,
) => {
  const [stompClient, setStompClient] = useState<Client | null>(null);
  const { loadChatSocket } = useLoadChatSocket();

  useEffect(() => {
    const client = loadChatSocket((message) => {
      messageSentCallback(message);
    });

    client.activate();
    setStompClient(client);

    return () => {
      client.deactivate();
    };
  }, [loadChatSocket, messageSentCallback]);

  const sendMessage = useCallback(
    (message: { senderId: any; receiverId: any; text: string }) => {
      if (stompClient && message.text.trim()) {
        stompClient.publish({
          destination: "/app/sendMessage",
          body: JSON.stringify(message),
        });
      }
    },
    [stompClient],
  );

  return { sendMessage };
};
